import useApiQuery from 'shared/hooks/use-api-query';
import {SegmentProps} from '../types';

const useSegmentsByCitySelect = (cityId?: string) => {
  const {data = [], ...rest} = useApiQuery({
    url: `/segments/all/cities/${cityId}`,
    enabled: !!cityId,
  });

  return {
    ...rest,
    data: data?.map((segment: SegmentProps) => ({
      label: segment.name,
      value: segment.id,
    })),
  };
};

export default useSegmentsByCitySelect;
